var React = require('react');

function Block (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.329 19.743A9.958 9.958 0 0 1 12 22C6.477 22 2 17.523 2 12c0-2.401.846-4.605 2.257-6.329L18.33 19.743zm1.414-1.414L5.67 4.257A9.959 9.959 0 0 1 12 2c5.523 0 10 4.477 10 10a9.958 9.958 0 0 1-2.257 6.329zM24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12z","fill":"#fff"}));
}

Block.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Block;

Block.default = Block;
